module.exports = __webpack_public_path__ + "img/logo-bold-beta-small.0dd532c5.png";